import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=81f457d4&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f457d4",
  null
  
)

export default component.exports